import React from 'react';
import Time from 'react-time';
import { useLocation } from 'react-router-dom';
import { Button, Table } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';
import AuthorizedAction from '../AuthorizedAction.js';
import { EditFileLink } from '../links/index.jsx';
import styles from './FileTable.module.css';

const FileTableRow = (
  file,
  isInitiative,
  initiativeType,
  manageProjectEntities,
  archived
) => {
  const { groupRoles, id, url, name, initiative, owner, createdAt } = file;
  const renderGroupRoles = () => {
    return (
      <AuthorizedAction action="read" subject="linkedFile">
        <div className="flex flex-col flex-align-start">
          {groupRoles.map((groupRole, index) => (
            <div key={index} className="" style={{ margin: '5px' }}>
              <span className="text-capitalize">
                {groupRole === 'viewer' ? 'group viewer' : groupRole}
              </span>
            </div>
          ))}

          {groupRoles.length <= 0 ? '—' : null}
        </div>
      </AuthorizedAction>
    );
  };

  const RenderEditFileLink = ({ children }) =>
    isInitiative ? (
      <AuthorizedAction action="update" subject={`${initiativeType}Initiative`}>
        {children}
      </AuthorizedAction>
    ) : (
      children
    );

  return (
    <tr key={id}>
      <td>
        <h3>
          <a target="_blank" href={url} rel="noreferrer">
            {name}
          </a>
        </h3>
      </td>
      {!isInitiative && (
        <td>
          <strong>{initiative ? initiative.title : '—'}</strong>
        </td>
      )}
      <td>
        <strong className={owner && owner.archived ? 'text-muted' : ''}>
          {owner.fullName}
        </strong>
      </td>
      <td>
        <strong>{groupRoles ? renderGroupRoles(groupRoles) : '—'}</strong>
      </td>
      <td>
        <strong>
          <Time value={createdAt} format="M/D/YY" />
        </strong>
      </td>
      <td className="text-right">
        <Button target="_blank" href={url} bsStyle="primary">
          Open File
        </Button>
        &nbsp;&nbsp;
        {manageProjectEntities ? (
          archived ? (
            <Button
              onClick={() =>
                window.alert(getOrgTermsContent('archivedProjectMessage'))
              }
              bsStyle="default"
              className="btn-edit"
            >
              Edit
            </Button>
          ) : (
            <RenderEditFileLink>
              <EditFileLink fileId={id}>
                <Button bsStyle="default" className="btn-edit">
                  Edit
                </Button>
              </EditFileLink>
            </RenderEditFileLink>
          )
        ) : null}
      </td>
    </tr>
  );
};

const FileTable = ({
  files,
  archived,
  initiativeType,
  manageProjectEntities,
}) => {
  const location = useLocation();
  const isInitiative = !location.pathname.includes('/projects/');
  return (
    <Table hover className={styles.fileTable}>
      <thead>
        <tr>
          <th>File Name</th>
          {!isInitiative && <th>{getOrgTermsContent('initiative')}</th>}
          <th style={{ minWidth: '145px' }}>Uploaded By</th>
          <th style={{ minWidth: '170px' }}>Who Can Access</th>
          <th style={{ minWidth: '160px' }}>Date Uploaded</th>
          <th className="text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        {files.map((file) =>
          FileTableRow(
            file,
            isInitiative,
            initiativeType,
            manageProjectEntities,
            archived
          )
        )}
      </tbody>
    </Table>
  );
};

export default FileTable;
